import { render, staticRenderFns } from "./compl.vue?vue&type=template&id=7ca50ee4&scoped=true&"
var script = {}
import style0 from "./compl.vue?vue&type=style&index=0&id=7ca50ee4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca50ee4",
  null
  
)

export default component.exports